import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react"

import styles from "./oneStar.module.scss";

type TOneStarProps = {
    averageRating?: number,
    className?: string
}

export const OneStar: FC<TOneStarProps> = ({ averageRating, className }: TOneStarProps) => {
    let percentagePoint = averageRating ? Math.round(averageRating * 100.0) : 100;

    return (
        <div className={`${styles.oneStar} ${className ? className : ""}`}>
            <FontAwesomeIcon icon={faStar} />
            {averageRating && averageRating >= 0.0 ?
                <FontAwesomeIcon style={{clipPath: averageRating > 0.98 ? "" : `inset(0 ${percentagePoint}% 0 0)`}} className={styles.filled} icon={faStar} />
                : <></>
            }
        </div>
    );
}

